import { GHLLanguageKeys as r } from "./ghl-ui.es269.js";
import e from "./ghl-ui.es843.js";
const f = {
  name: r.frenchFrance,
  locale: e
};
export {
  f as date_fr_FR
};
